import React from 'react'

import * as RadixRadioGroup from '@radix-ui/react-radio-group'
import {
  radioGroup,
  radioGroupItem,
  radioGroupItemContainer,
  radioGroupItemIndicator,
  radioGroupItemLabel,
} from './RadioGroup.css'

type RadioGroupProps = {
  children: React.ReactNode
  defaultValue?: string
  value?: string
  onChange: (value: string) => void
}

export const RadioGroup = (props: RadioGroupProps) => {
  const {
    children,
    onChange,
    value = undefined,
    defaultValue = undefined,
  } = props

  return (
    <RadixRadioGroup.Root
      className={radioGroup}
      defaultValue={defaultValue}
      value={value}
      onValueChange={onChange}
    >
      {children}
    </RadixRadioGroup.Root>
  )
}

const RadioGroupItem = ({ children, value }) => {
  return (
    <div className={radioGroupItemContainer}>
      <RadixRadioGroup.Item className={radioGroupItem} value={value} id={value}>
        <RadixRadioGroup.Indicator className={radioGroupItemIndicator} />
      </RadixRadioGroup.Item>
      <label className={radioGroupItemLabel} htmlFor={value}>
        {children}
      </label>
    </div>
  )
}

RadioGroup.Item = RadioGroupItem
